/**
 * Writes `text` to the system clipboard via the async Clipboard API.
 * Returns the promise from `navigator.clipboard.writeText` so callers can
 * await success or catch failures (e.g. when clipboard permission is denied
 * or `navigator.clipboard` is unavailable in insecure contexts).
 */
export default function copyToClipboard(text: string): Promise<void> {
    return navigator.clipboard.writeText(text);
}
